import { render, staticRenderFns } from "./PartnerRegister.vue?vue&type=template&id=a9b2ac6a&scoped=true"
import script from "./PartnerRegister.vue?vue&type=script&lang=js"
export * from "./PartnerRegister.vue?vue&type=script&lang=js"
import style0 from "./PartnerRegister.vue?vue&type=style&index=0&id=a9b2ac6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b2ac6a",
  null
  
)

export default component.exports